import i18n from 'i18next';
import { BaseDocumentConvertModalProps } from './BaseDocumentConvertModal';

type DocumentFileFormat =
  | 'DocumentUpload'
  | 'DocumentUploadOneDrive'
  | 'QualioNativeDocument';
type DocumentFileFormatMessageConfig = Pick<
  BaseDocumentConvertModalProps,
  'messageList' | 'warningText' | 'messageListPrompt'
>;

export const DocumentConvertMessageConfig: {
  [k in DocumentFileFormat]: DocumentFileFormatMessageConfig;
} = {
  DocumentUploadOneDrive: {
    warningText: i18n.t('convertFormat.oneDriveConnectionWillBeRemoved'),
    messageListPrompt: i18n.t('convertFormat.convertingToEditableDocument'),
    messageList: [
      i18n.t('convertFormat.connectionToOneDriveLost'),
      i18n.t('convertFormat.documentNowEditableOriginalAttached'),
    ],
  },
  DocumentUpload: {
    warningText: i18n.t('convertFormat.fileWillBecomeEditableDocument'),
    messageListPrompt: i18n.t('convertFormat.convertingToEditableDocument'),
    messageList: [
      i18n.t('convertFormat.documentNowEditable'),
      i18n.t('convertFormat.fileWillBeAttached'),
    ],
  },
  QualioNativeDocument: {
    warningText: i18n.t('convertFormat.documentNoLongerEditable'),
    messageList: [
      i18n.t('convertFormat.attachmentWillReplaceContent'),
      i18n.t('convertFormat.editsWillBeLost'),
    ],
  },
};
